import { useBookingLocationState } from "./UseBookingLocationState";
import { useBookingConfig } from "./UseBookingConfig";
import { useBookingDateState } from "./UseBookingDateState";
import BookingGetters from "../../../store/onlineBooking/getters";

export const useBookingFormState = () => {
  const reduxBookingDetails = BookingGetters.getBookingDetails();
  const { maxRentalAllowedDay, minRentalAllowedDay } = useBookingConfig();

  const {
    pickupLocation,
    setPickupLocation,
    reservationDestination,
    setReservationDestination,
  } = useBookingLocationState(
    reduxBookingDetails.pickUpLocationName || "",
    reduxBookingDetails.dropOffLocationName || ""
  );

  const { reservationStartDate, setStartDate, reservationEndDate, setEndDate } =
    useBookingDateState(
      reduxBookingDetails.pickUpDateAndTime,
      reduxBookingDetails.dropOffDateAndTime
    );

  return {
    pickupLocation,
    setPickupLocation,
    reservationDestination,
    setReservationDestination,
    reservationStartDate,
    setStartDate,
    reservationEndDate,
    setEndDate,
    maxRentalAllowedDay,
    minRentalAllowedDay,
  };
};
